//@ts-nocheck
import { Registry } from '@react-registry'
import { Editor, Range, Transforms, Node, Element, Text, Path } from 'slate'
import { v4 } from 'uuid'
import { outdentListItem, exitList, outdentListItemForUpdatedListStructure, indentListItemForUpdatedListStructure } from './utils'
import { LIST_TYPES, handleTableInList, removeListMarker, updateLiWithNewNodeChildren } from '../utils'
import { jsx } from 'slate-hyperscript'
import { isInlineElement } from '../../../../utils/queries/index'

export const withListItem = (editor: Editor) => {
  const { deleteBackward, normalizeNode, insertBreak } = editor

  editor.normalizeNode = (entry) => {
    const rteVersion = editor.rteVersion
    if (editor.stopNormalizeNode) {
      return
    }

    // convert stranded li to paragraph
    if (entry[0] && Element.isElement(entry[0]) && entry[0].type === 'li' && entry[1]?.length >= 1) {
      const parent: any = Node.get(editor, entry[1].slice(0, entry[1].length - 1))
      if (Element.isElement(parent) && !LIST_TYPES.includes(String(parent.type))) {
        Transforms.setNodes(editor, { type: 'p' }, { at: entry[1] })
      }
    }

    // convert child of ol and ul to li if not already
    if (entry[0] && LIST_TYPES.includes(entry[0].type) && entry[0]?.children?.length) {
      for (const [i, child] of entry[0].children.entries()) {
        if (!(Element.isElement(child) && (child.type === 'li' || LIST_TYPES.includes(String(child.type))))) {
          if (!child.hasOwnProperty('text') && child?.type !== 'fragment') {
            if (Path.hasPrevious([...entry[1], i])) {
              let previousChildPath = Path.previous([...entry[1], i])
              const previousChild = Node.get(editor, previousChildPath)
              if (Node.string(previousChild) === '' && !checkIfListItemHasContent(editor, previousChildPath)) {
                Transforms.removeNodes(editor, { at: previousChildPath })
              }
            }
            Transforms.wrapNodes(
              editor,
              { type: 'li', attrs: {}, uid: v4().split('-').join('') },
              { at: [...entry[1], i] }
            )
          }
        }
      }
    }
    //coverting to new Nested List Structure.
    if (entry[0] && LIST_TYPES.includes(entry[0].type) && entry[0]?.children.length >= 2 && rteVersion >= 1) {
      let findIfAllChildrenAreOfTypeLI = Array.from(entry[0].children).every((elem) => elem.type === 'li')
      if (!findIfAllChildrenAreOfTypeLI) {
        Array.from(entry[0].children).forEach((child, i) => {
          if (child.type && LIST_TYPES.includes(child.type)) {
            updateLiWithNewNodeChildren(editor, child)
          }
        })
        return
      }
    }

    if (entry[0] && LIST_TYPES.includes(entry[0].type) && entry[0]?.children.length >= 2) {
      let child = []
      child.push(entry[0].children[0])
      let fixed = false
      for (var i = 0, j = 1; i < entry[0].children.length - 1; i++, j++) {
        const el = entry[0].children[j]
        if (LIST_TYPES.includes(el.type) && el.type === entry[0].children[i].type) {
          let prev = child.pop()
          let orderChild = [...prev.children, ...el.children]
          let newChild = { ...prev }
          newChild.children = orderChild
          child.push(newChild)
          fixed = true
        } else {
          child.push(el)
        }
      }
      if (fixed) {
        let newNode = { ...entry[0] }
        newNode.children = child
        Transforms.removeNodes(editor, { at: entry[1] })
        Transforms.insertNodes(editor, newNode, { at: entry[1] })
        return
      }
    }
    if (LIST_TYPES.includes(entry[0].type) && entry[0].children.length === 0) {
      Transforms.removeNodes(editor, { at: entry[1] })
      return
    }
    // CS-39094 -- cannot remove list item with table
    if (entry[0] && Element.isElement(entry[0]) && entry[0].type === 'li') {
      const [node, path] = entry
      if (node?.children?.length && Node.child(node, 0)?.type === 'table') {
        Transforms.insertNodes(editor, jsx('element', { type: 'p' }, jsx('text')), { at: [...path, 0] })
      }
    }

    if (entry[0] && Element.isElement(entry[0]) && (entry[0].type === 'li' || entry[0].type === 'span')) {
      let elementChildren = entry[0].children;
      const hasBlockAndInlineChildren = Boolean(elementChildren.find((child) => !isInlineElement(child) && Element.isElement(child)));
      if (hasBlockAndInlineChildren) {
        elementChildren.forEach((currentChild, i) => {
          if (!Element.isElement(currentChild)) {
            Transforms.wrapNodes(
              editor,
              { type: 'fragment', attrs: {}, uid: v4().split('-').join('') },
              { at: [...entry[1], i] }
            )
          }
        })

        if (entry[0].type === 'span') {
          Transforms.setNodes(editor, { type: 'div', attrs: { orgType: "span" } }, { at: entry[1] })
        }

        return;
      }
    }

    normalizeNode(entry)
  }
  editor.deleteBackward = (data) => {
    const { selection, rteVersion } = editor
    if (selection) {
      if (rteVersion >= 1) {
        const [li] = Editor.nodes(editor, { match: (n) => n.type === 'li', mode: 'lowest' })

        if (li && Range.isCollapsed(selection) && selection.anchor.offset === 0) {
          if (li[1].length >= 3) {
            // ol -> li -> ol
            const grandparent: any = Node.get(editor, li[1].slice(0, -3))
            if (LIST_TYPES.includes(grandparent.type)) {
              outdentListItemForUpdatedListStructure(editor, li)
            } else {
              const isFirstListElement = !li[1].at(-1);
              if (Node.string(Node.first(editor, li[1])?.[0]) === '') {
                const ref = Editor.pathRef(editor, li[1])
                indentListItemForUpdatedListStructure(editor, li)
                Transforms.move(editor, { unit: 'offset', reverse: true })
                Transforms.removeNodes(editor, { at: ref.current })
                return
              }
              // if list item is the first el
              else if (isFirstListElement) {
                Transforms.unwrapNodes(editor, {
                  match: (n: any) => LIST_TYPES.includes(n.type),
                  split: true
                })
                return
              }
              deleteBackward(data)
            }
            return
          } else {
            // if list item is not first element then merge it with previous one
            if (li[1][li[1].length - 1]) {
              if (li[0].children.find((child) => child.type === 'table')) {
                try {
                  if (handleTableInList(editor, liPath)) return
                } catch (err) {
                  if (err instanceof Error) {
                    err.message = 'Error while deleting backward in list with table: ' + err.message
                    console.error(err, JSON.stringify({ selection: editor.selection, children: editor.children }))
                  }
                }
              }
              deleteBackward(data)
            }
            // remove the list marker
            else {
              removeListMarker(editor, li)
            }
            return
          }
        }
      }
      else {
        const [li] = Editor.nodes(editor, { match: (n) => n.type === 'li' })

        if (li && Range.isCollapsed(selection) && Editor.isStart(editor, selection.anchor, li[1])) {
          const liPath = li[1]
          if (li[1].length >= 4) {
            const grandparent: any = Node.get(editor, li[1].slice(0, li[1].length - 2))
            if (LIST_TYPES.includes(grandparent.type)) {
              outdentListItem(editor, li)
            } else {
              Transforms.unwrapNodes(editor, {
                match: (n: any) => LIST_TYPES.includes(n.type),
                split: true
              })
              Transforms.setNodes(editor, { type: 'p' })
            }
            return
          } else {
            // if list item is not first element then merge it with previous one
            if (li[1][li[1].length - 1]) {
              // if li has table child

              if (li[0].children.find((child) => child.type === 'table')) {
                try {
                  if (handleTableInList(editor, liPath)) return
                } catch (err) {
                  if (err instanceof Error) {
                    err.message = 'Error while deleting backward in list with table: ' + err.message
                    console.error(err, JSON.stringify({ selection: editor.selection, children: editor.children }))
                  }
                }
              }

              deleteBackward(data)
            }
            // remove the list marker
            else {
              removeListMarker(editor, li)
            }
            return
          }
        }
      }
    }
    // if (li && Range.isCollapsed(selection) && selection.anchor.offset === 0) {
    //   const currentPath = selection.anchor.path.slice(0, selection.anchor.path.length - 1)
    //   const currentPathLastIndex = currentPath.length - 1

    //   if (currentPath[currentPathLastIndex]) {
    //     const prevSiblingPath = [...currentPath.slice(0, currentPathLastIndex), currentPath[currentPathLastIndex] - 1]
    //     const prevSibling: any = Node.get(editor, prevSiblingPath)

    //     const getLastChild = (prevSiblingPath) => {
    //       let currentPath = [...prevSiblingPath]
    //       let currentNode = Node.get(editor, currentPath)
    //       let offset = 0

    //       while (true) {
    //         if (Element.isElement(currentNode)) {
    //           currentPath.push(currentNode.children.length - 1)
    //           currentNode = Node.get(editor, currentPath)
    //           continue
    //         } else if (Text.isText(currentNode)) {
    //           offset = currentNode.text.length
    //           break
    //         } else {
    //           // console.error('List must have child as list-item')
    //           break
    //         }
    //       }
    //       return { path: currentPath, offset }
    //     }

    //     if (LIST_TYPES.includes(prevSibling.type)) {
    //       const parent = Node.parent(editor, currentPath)
    //       if (parent.children.length - 1 > currentPath[currentPathLastIndex]) {
    //         const nextSibling: any = Node.get(editor, [
    //           ...currentPath.slice(0, currentPathLastIndex),
    //           currentPath[currentPathLastIndex] + 1,
    //         ])

    //         if (LIST_TYPES.includes(nextSibling.type) && prevSibling.type === nextSibling.type) {
    //           const cursorPoint = getLastChild(prevSiblingPath)

    //           if (cursorPoint.offset) {
    //             deleteBackward(data)
    //           } else {
    //             const replacementPath = cursorPoint.path.slice(0, cursorPoint.path.length - 1)
    //             const replacementNode = {
    //               type: 'li',
    //               children: [...Node.get(editor, currentPath).children],
    //             }

    //             Transforms.removeNodes(editor, { at: replacementPath })
    //             Transforms.removeNodes(editor, { at: currentPath })
    //             Transforms.insertNodes(editor, replacementNode, { at: replacementPath })
    //           }
    //           const modifiedPrevSibling = Node.get(editor, prevSiblingPath)
    //           const newChildren = [...modifiedPrevSibling.children, ...nextSibling.children]
    //           Transforms.removeNodes(editor, { at: currentPath })
    //           Transforms.removeNodes(editor, { at: prevSiblingPath })
    //           Transforms.insertNodes(
    //             editor,
    //             { type: prevSibling.type, children: newChildren },
    //             { at: prevSiblingPath }
    //           )

    //           Transforms.select(editor, cursorPoint)
    //           return
    //         }
    //       }
    //     }
    //   }
    // }

    deleteBackward(data)
  }

  editor.insertBreak = () => {
    if (!editor.insertBreakFromSoftBreak && editor.csBreakLineOnEnter) {
      editor.insertText('\n')
      return
    }
    if (!exitList(editor)) {
      insertBreak()
    }
  }

  return editor
}

Registry.register(withListItem, { id: 'withListItem', registry: 'v2.plugin' })
